import React from 'react';
import axios from 'axios';

const categories = [
    {
        id: 'auth',
        label: 'Autenticación',
        endpoints: [
            {
                id: 'api-login',
                label: 'Login',
                method: 'POST',
                path: '/api/login',
                bearer: false,
                description: 'Genera el token de acceso.',
                params: [
                    { name: 'email', label: 'email', location: 'body', required: true, defaultValue: '' },
                    { name: 'password', label: 'password', location: 'body', required: true, defaultValue: '' },
                ],
            },
        ],
    },
    {
        id: 'completed-dossiers',
        label: 'Completados expedientes',
        endpoints: [
            {
                id: 'persons-invitation',
                label: 'Invitar proveedor / completador',
                method: 'POST',
                path: '/api/persons/invitation',
                bearer: true,
                description: 'Crea invitaciones para proveedores o completadores.',
                bodyTemplate: '{\n  "country_id": 1,\n  "dossier_id": 3,\n  "providers": [\n    {\n      "name": "Jhon Doe",\n      "email": "test@example.com",\n      "rfc": "AAMH840630UUU",\n      "fiscal_name": "Nombre fiscal",\n      "country": 1,\n      "internalId": null,\n      "personType": 1\n    }\n  ],\n  "aditionalDocuments": []\n}',
                notes: [
                    'personType: 1 = Persona Física, 2 = Persona Moral',
                    'country_id/country: 1 = México, 2 = Colombia, 3 = Brasil',
                ],
            },
            {
                id: 'internal-id-by-rfc',
                label: 'Actualizar identificador interno por RFC',
                method: 'POST',
                path: '/api/internal_company_identifier/update-by-rfc',
                bearer: true,
                description: 'Actualiza o crea el identificador interno del proveedor encontrado por RFC.',
                params: [
                    { name: 'rfc', label: 'rfc', location: 'body', required: true, defaultValue: '' },
                    { name: 'internal_id', label: 'internal_id', location: 'body', required: true, defaultValue: '' },
                ],
            },
            {
                id: 'providers',
                label: 'Lista de expedientes de completadores',
                method: 'GET',
                path: '/api/persons/providers',
                bearer: true,
                description: 'Lista expedientes de completadores; el backend soporta maxRecords.',
                params: [
                    { name: 'start_date', label: 'start_date', location: 'query', required: false, defaultValue: '' },
                    { name: 'maxRecords', label: 'maxRecords', location: 'query', required: false, defaultValue: '' },
                ],
            },
            {
                id: 'providers-dossiers',
                label: 'Lista compacta de expedientes de completadores',
                method: 'GET',
                path: '/api/persons/providers/dossiers',
                bearer: true,
                description: 'Lista compacta; provider_id filtra por persona proveedora.',
                params: [
                    { name: 'provider_id', label: 'provider_id', location: 'query', required: false, defaultValue: '' },
                ],
            },
            {
                id: 'providers-list',
                label: 'Listado de completadores',
                method: 'GET',
                path: '/api/persons/providers/list',
                bearer: true,
                description: 'Listado compacto de completadores.',
                params: [
                    { name: 'maxRecords', label: 'maxRecords', location: 'query', required: false, defaultValue: '' },
                ],
            },
            {
                id: 'provider-dossier-status',
                label: 'Status del expediente de un proveedor',
                method: 'GET',
                path: '/api/providers/provider_dossier_status',
                bearer: true,
                description: 'Obtiene el status de un expediente por provider_id.',
                params: [
                    { name: 'provider_id', label: 'provider_id', location: 'query', required: true, defaultValue: '' },
                ],
            },
            {
                id: 'dossiers-by-rfc',
                label: 'Status / expedientes por RFC',
                method: 'GET',
                path: '/api/providers/dossiers/byrfc/{rfc}',
                bearer: true,
                description: 'Obtiene expedientes del proveedor por RFC.',
                params: [
                    { name: 'rfc', label: 'rfc', location: 'path', required: true, defaultValue: '' },
                ],
            },
            {
                id: 'dossier-statuses',
                label: 'Catálogo de status de expedientes',
                method: 'GET',
                path: '/api/dossier_statuses',
                bearer: true,
                description: 'Regresa el catálogo de status.',
                params: [],
            },
            {
                id: 'providers-dossier-status',
                label: 'Status de todos los expedientes',
                method: 'GET',
                path: '/api/providers/providers_dossier_status',
                bearer: true,
                description: 'Lista status de expedientes, opcionalmente paginado y filtrado por RFC.',
                params: [
                    { name: 'paginate', label: 'paginate', location: 'query', required: true, defaultValue: 'false' },
                    { name: 'per_page', label: 'per_page', location: 'query', required: true, defaultValue: '10' },
                    { name: 'page', label: 'page', location: 'query', required: true, defaultValue: '1' },
                    { name: 'rfc', label: 'rfc', location: 'query', required: false, defaultValue: '' },
                ],
            },
            {
                id: 'dossiers',
                label: 'Obtener plantillas de expedientes',
                method: 'GET',
                path: '/api/dossiers',
                bearer: true,
                description: 'Lista plantillas de expedientes del usuario autenticado.',
                params: [
                    { name: 'maxRecords', label: 'maxRecords', location: 'query', required: false, defaultValue: '' },
                ],
            },
        ],
    },
    {
        id: 'documents',
        label: 'Documents',
        endpoints: [
            {
                id: 'provider-files',
                label: 'Obtener documentos de expediente',
                method: 'GET',
                path: '/api/providers/provider_files',
                bearer: true,
                description: 'Obtiene documentos por proveedor y status.',
                params: [
                    { name: 'provider_id', label: 'provider_id', location: 'query', required: true, defaultValue: '' },
                    { name: 'status', label: 'status', location: 'query', required: true, defaultValue: '1' },
                ],
                notes: ['status: 1 = Por cargar, 2 = Por revisar, 3 = Aprobado, 4 = Rechazado'],
            },
        ],
    },
    {
        id: 'webhooks',
        label: 'Webhooks',
        endpoints: [
            {
                id: 'webhooks-subscribe',
                label: 'Suscribir URL a eventos',
                method: 'POST',
                path: '/api/webhooks/subscribe',
                bearer: true,
                description: 'Da de alta o actualiza una URL para recibir los eventos disponibles de webhooks.',
                bodyTemplate: '{\n  "target_url": "https://example.com/webhooks/exppedify",\n  "subscribed_events": [\n    "person_provider.status_changed",\n    "people.updated"\n  ],\n  "is_active": true,\n  "rotate_secret": true\n}',
                notes: [
                    'person_provider.status_changed: se envía cuando cambia el estatus de un expediente de proveedor.',
                    'people.updated: se envía cuando cambia cualquier campo del registro People.',
                    'La respuesta incluye secret y generated_secret cuando se crea o rota el secret; cópialo en ese momento.',
                    'Los envíos se firman con X-Exppedify-Signature usando HMAC SHA-256 sobre X-Exppedify-Timestamp + "." + rawBody.',
                ],
            },
        ],
    },
];

function firstEndpoint() {
    return categories[0].endpoints[0];
}

function findEndpoint(categoryId, endpointId) {
    const category = categories.find((item) => item.id === categoryId) || categories[0];
    return category.endpoints.find((item) => item.id === endpointId) || category.endpoints[0] || null;
}

function defaultParams(endpoint) {
    return (endpoint.params || []).reduce((values, param) => ({
        ...values,
        [param.name]: param.defaultValue || '',
    }), {});
}

function normalizeHost(host) {
    const value = host.trim() || window.location.origin;
    return value.replace(/\/$/, '');
}

export default class DeveloperApi extends React.Component {
    constructor(props) {
        super(props);
        const endpoint = firstEndpoint();
        this.state = {
            host: window.location.origin,
            bearerToken: '',
            activeCategory: categories[0].id,
            activeEndpoint: endpoint.id,
            params: defaultParams(endpoint),
            body: endpoint.bodyTemplate || '',
            loading: false,
            result: null,
            error: null,
        };
    }

    setEndpointState = (categoryId, endpoint) => {
        this.setState({
            activeCategory: categoryId,
            activeEndpoint: endpoint ? endpoint.id : '',
            params: endpoint ? defaultParams(endpoint) : {},
            body: endpoint?.bodyTemplate || '',
            result: null,
            error: null,
        });
    };

    selectCategory = (categoryId) => {
        const category = categories.find((item) => item.id === categoryId);
        this.setEndpointState(categoryId, category.endpoints[0] || null);
    };

    selectEndpoint = (endpoint) => {
        this.setEndpointState(this.state.activeCategory, endpoint);
    };

    updateParam = (name, value) => {
        this.setState((state) => ({
            params: {
                ...state.params,
                [name]: value,
            },
        }));
    };

    endpointUrl = (endpoint) => {
        const { host, params } = this.state;
        let path = endpoint.path;
        const query = new URLSearchParams();

        (endpoint.params || []).forEach((param) => {
            const value = params[param.name];
            if (param.location === 'path') {
                path = path.replace(`{${param.name}}`, encodeURIComponent(value || ''));
                return;
            }

            if (param.location === 'query' && value !== undefined && value !== '') {
                query.append(param.name, value);
            }
        });

        const queryString = query.toString();
        return `${normalizeHost(host)}${path}${queryString ? `?${queryString}` : ''}`;
    };

    requestBody = (endpoint) => {
        const { body, params } = this.state;

        if (endpoint.bodyTemplate) {
            if (body.trim() === '') {
                return undefined;
            }

            return JSON.parse(body);
        }

        const payload = {};
        (endpoint.params || []).forEach((param) => {
            if (param.location === 'body') {
                payload[param.name] = params[param.name];
            }
        });

        return Object.keys(payload).length ? payload : undefined;
    };

    validateParams = (endpoint) => {
        const missing = (endpoint.params || [])
            .filter((param) => param.required && !this.state.params[param.name])
            .map((param) => param.name);

        if (missing.length > 0) {
            return `Faltan parámetros requeridos: ${missing.join(', ')}.`;
        }

        return null;
    };

    tryEndpoint = async () => {
        const endpoint = findEndpoint(this.state.activeCategory, this.state.activeEndpoint);
        if (!endpoint) {
            return;
        }

        const missingMessage = this.validateParams(endpoint);
        if (missingMessage) {
            this.setState({ error: missingMessage, result: null });
            return;
        }

        let data;
        try {
            data = this.requestBody(endpoint);
        } catch (error) {
            this.setState({ error: 'El body no es JSON válido.', result: null });
            return;
        }

        this.setState({ loading: true, error: null, result: null });

        try {
            const headers = { Accept: 'application/json' };
            if (endpoint.bearer && this.state.bearerToken.trim() !== '') {
                headers.Authorization = `Bearer ${this.state.bearerToken.trim()}`;
            }

            const response = await axios.request({
                method: endpoint.method,
                url: this.endpointUrl(endpoint),
                data,
                headers,
            });

            this.setState({
                result: {
                    status: response.status,
                    data: response.data,
                },
            });
        } catch (error) {
            this.setState({
                result: {
                    status: error.response ? error.response.status : null,
                    data: error.response ? error.response.data : { message: error.message },
                },
            });
        } finally {
            this.setState({ loading: false });
        }
    };

    renderParam = (param) => (
        <div className="col-md-6 form-group" key={param.name}>
            <label className="font-weight-bolder">
                {param.label}
                {param.required && <span className="text-danger ml-1">*</span>}
            </label>
            <input
                className="form-control form-control-solid"
                value={this.state.params[param.name] || ''}
                onChange={(event) => this.updateParam(param.name, event.target.value)}
                placeholder={param.location}
            />
        </div>
    );

    render() {
        const { host, bearerToken, activeCategory, activeEndpoint, body, loading, result, error } = this.state;
        const category = categories.find((item) => item.id === activeCategory) || categories[0];
        const endpoint = findEndpoint(activeCategory, activeEndpoint);
        const url = endpoint ? this.endpointUrl(endpoint) : '';

        return (
            <>
                <div className="card card-custom gutter-b">
                    <div className="card-body">
                        <div className="row align-items-end">
                            <div className="col-lg-4 form-group mb-lg-0">
                                <label className="font-weight-bolder">Host</label>
                                <input
                                    className="form-control form-control-solid"
                                    value={host}
                                    onChange={(event) => this.setState({ host: event.target.value })}
                                    placeholder="https://exppedifydev.dygne.com"
                                />
                            </div>
                            <div className="col-lg-8 form-group mb-lg-0">
                                <label className="font-weight-bolder">Bearer token</label>
                                <input
                                    type="password"
                                    className="form-control form-control-solid"
                                    value={bearerToken}
                                    onChange={(event) => this.setState({ bearerToken: event.target.value })}
                                    placeholder="Pega tu token aquí; se usará al navegar entre endpoints"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-3 mb-5">
                    <div className="card card-custom gutter-b">
                        <div className="card-body p-5">
                            <div className="font-weight-bolder text-dark mb-4">Categorías</div>
                            <div className="d-flex flex-column">
                                {categories.map((item) => (
                                    <button
                                        key={item.id}
                                        type="button"
                                        className={`btn btn-block text-left mb-2 border-0 ${item.id === activeCategory ? 'btn-primary text-white' : 'btn-white text-dark'}`}
                                        onClick={() => this.selectCategory(item.id)}
                                    >
                                        {item.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="card card-custom gutter-b">
                        <div className="card-body p-5">
                            <div className="font-weight-bolder text-dark mb-4">Endpoints</div>
                            {category.endpoints.map((item) => (
                                <button
                                    key={item.id}
                                    type="button"
                                    className={`btn btn-block text-left mb-2 border-0 ${item.id === activeEndpoint ? 'btn-primary text-white' : 'btn-white text-dark'}`}
                                    onClick={() => this.selectEndpoint(item)}
                                >
                                    <span className="font-weight-bolder mr-2">{item.method}</span>
                                    {item.path}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="col-lg-9">
                    <div className="card card-custom gutter-b">
                        <div className="card-body">
                            <div className="d-flex align-items-start justify-content-between flex-wrap mb-5">
                                <div>
                                    <h3 className="font-weight-bolder text-dark mb-1">{endpoint?.label}</h3>
                                    <div className="text-muted">{endpoint?.description}</div>
                                </div>
                                {endpoint?.bearer ? (
                                    <span className="label label-inline label-light-primary font-weight-bold mt-2">Bearer requerido</span>
                                ) : (
                                    <span className="label label-inline label-light-success font-weight-bold mt-2">Sin bearer</span>
                                )}
                            </div>
                            <div className="row">
                                <div className="col-md-3 form-group">
                                    <label className="font-weight-bolder">Método</label>
                                    <input className="form-control form-control-solid" value={endpoint?.method || ''} readOnly />
                                </div>
                                <div className="col-md-9 form-group">
                                    <label className="font-weight-bolder">URL</label>
                                    <input className="form-control form-control-solid" value={url} readOnly />
                                </div>
                            </div>
                            {endpoint?.params?.length > 0 && (
                                <div className="row">
                                    {endpoint.params.map(this.renderParam)}
                                </div>
                            )}
                            {endpoint?.bodyTemplate && (
                                <div className="form-group">
                                    <label className="font-weight-bolder">Body JSON</label>
                                    <textarea
                                        className="form-control form-control-solid font-family-monospace"
                                        rows="14"
                                        value={body}
                                        onChange={(event) => this.setState({ body: event.target.value })}
                                    />
                                </div>
                            )}
                            {endpoint?.notes?.length > 0 && (
                                <div className="alert alert-light mb-5">
                                    {endpoint.notes.map((note) => <div key={note}>{note}</div>)}
                                </div>
                            )}
                            {error && <div className="alert alert-danger">{error}</div>}
                            <button
                                type="button"
                                className="btn btn-primary font-weight-bolder"
                                disabled={!endpoint || loading}
                                onClick={this.tryEndpoint}
                            >
                                {loading ? 'Ejecutando...' : 'Try'}
                            </button>
                        </div>
                    </div>
                    <div className="card card-custom gutter-b">
                        <div className="card-header border-0 pt-6">
                            <h3 className="card-title font-weight-bolder text-dark">Resultado</h3>
                        </div>
                        <div className="card-body pt-0">
                            {!result && <div className="text-muted">Ejecuta un endpoint para ver la respuesta.</div>}
                            {result && (
                                <>
                                    <div className="mb-3">
                                        <span className="label label-inline label-light-primary font-weight-bold">HTTP {result.status || 'ERROR'}</span>
                                    </div>
                                    <pre className="bg-light rounded p-4 mb-0" style={{ whiteSpace: 'pre-wrap', maxHeight: '480px', overflow: 'auto' }}>
                                        {JSON.stringify(result.data, null, 2)}
                                    </pre>
                                </>
                            )}
                        </div>
                    </div>
                </div>
                </div>
            </>
        );
    }
}
